import IconButton from "components/Button/IconButton";

import { dataEmpty, simpleAlert } from "components/CommonLib/CommonLib";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import {
  CustomRow,
  CustomTableContents,
  CustomTableContentsEND,
} from "components/CustomTable/tableStyle";
import ComboBox from "components/LabelInput/ComboBox";
import Label from "components/LabelInput/Label";
import Loading from "components/Loading/Loading/Loading";
import ModalPopupLocal from "components/ModalPopup/ModalPopupLocal";
import NormalBtn from "components/NewButton/NormalBtn";
import { useHolyDayInfo } from "hooks/apis/branch/useDeviceManage";
import { HttpInstance } from "lib/HttpLib";
import { globalAlertOn } from "modules/actions/Alert";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import HolidayAddModal from "./HolidayAddModal";

const HolidayListView = () => {
  const storesDispatch = useDispatch();
  const viewModelRef = useRef();
  const [modalInfo, setModalInfo] = useState({
    show: false,
    title: "",
    Content: "",
    callback: null,
    Buttons: undefined,
  });
  const [currentYear, setCurrentYear] = useState("2023");
  const [loading, setLoading] = useState(false);
  const [holyDayList, setHolyDayList] = useState([]);

  const queryData = {
    date_year: currentYear,
  };
  const { data: holyDayInfoData, refetch } = useHolyDayInfo(queryData);

  const localModalDone = () => {
    viewModelRef.current.setClose();
  };

  //공휴일 추가 모달 POP
  const onModalOpen = (data) => {
    const params = {
      date_year: currentYear,
    };
    setModalInfo({
      show: true,
      title: "공휴일 추가",
      Content: <HolidayAddModal modalParam={params} onModalDone={localModalDone} />,
      callback: null,
      Buttons: undefined,
    });
  };

  //공휴일 삭제 POST

  const deleteDay = async (data) => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const formData = new FormData();
      formData.append("param_info", JSON.stringify(data));
      const res = await HttpInstance.post(
        process.env.REACT_APP_BRANCH_SERVER + "/access/remove_holy_day",
        formData,
        config,
      );
      if (res.data.msg) {
        simpleAlert(storesDispatch, "ERROR", res.data.msg);
      } else {
        refetch();
      }
    } catch (err) {
      console.log(err);
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    } finally {
      setLoading(false);
    }
  };

  const onRemoveDay = async (data) => {
    storesDispatch(
      globalAlertOn({
        show: true,
        titleText: "알림",
        reqConfirm: true,
        bodyText: (
          <>
            <Label labelText={`공휴일을 삭제하시겠습니까?`} fontWeight={"bold"} />
            <Label labelText={`공휴일 명:${data.date_name}`} />
            <Label labelText={`날짜:${data.date} `} />
          </>
        ),

        onBtnYes: () => {
          deleteDay(data);
        },
        onBtnNo: () => {},
      }),
    );
  };

  // 데이터 세팅
  useEffect(() => {
    if (holyDayInfoData) {
      setHolyDayList(holyDayInfoData.data.data.holiday_list);
    }
  }, [holyDayInfoData]);

  const holidayInfoTableItem = new holidayInfoTable(onRemoveDay);

  return (
    <div
      style={{
        width: "37.5rem",
      }}
    >
      {loading && <Loading />}

      <ModalPopupLocal ref={viewModelRef} params={modalInfo} />
      <div style={{ display: "flex" }}>
        <ComboBox
          labelWidth={"4.5rem"}
          comboItemWidth={"8.75rem"}
          labelText="연도 선택"
          data={["2022", "2023", "2024"]}
          defaultValue={"2023"}
          onChangeCallback={(e) => {
            setCurrentYear(e.target.value);
          }}
        />
        <div
          style={{
            float: "right",
            display: "flex",
            justifyContent: "end",
            width: "100%",
          }}
        >
          <NormalBtn name="추가" onClick={() => onModalOpen()} />
        </div>
      </div>
      <div style={{ marginTop: "0.5rem" }}>
        <CustomTable
          columns_head={holidayInfoTableItem.columns_head}
          table_title={holidayInfoTableItem.table_title}
          rest_call={holidayInfoTableItem.get_data_from_rest}
          row_render={holidayInfoTableItem.create_table}
          rest_data={holyDayList}
        />
      </div>
    </div>
  );
};
export default HolidayListView;

class holidayInfoTable {
  table_title = "";
  onRemoveDay = null;

  constructor(onRemoveDay) {
    this.onRemoveDay = onRemoveDay;
  }

  create_table = (data, idx) => {
    return (
      <CustomRow key={idx}>
        <CustomTableContents>{data.date}</CustomTableContents>
        <CustomTableContents>{data.date_name}</CustomTableContents>
        <CustomTableContentsEND align="center">
          <IconButton type="delete" onClick={() => this.onRemoveDay(data)} />
        </CustomTableContentsEND>
      </CustomRow>
    );
  };
  columns_head = [
    { title: "날짜", width: "33%" },
    { title: "공휴일 명", width: "33%" },
    { title: "삭제", width: "33%" },
  ];
  get_data_from_rest = (stateData) => {
    // console.log(stateData);
    if (dataEmpty(stateData)) {
      return [];
    }
    return stateData;
  };
}
